// src/client/hooks/useNotificationPrefs.ts
// Persists notification toggle state to localStorage.
// When real push notifications are wired up, sync these prefs to the profiles table.
import { useState } from 'react';

const STORAGE_KEY = 'thandizo_notification_prefs';

export interface NotificationPrefs {
  loanReminders: boolean;
  promotions: boolean;
}

const DEFAULTS: NotificationPrefs = { loanReminders: true, promotions: false };

function readPrefs(): NotificationPrefs {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? { ...DEFAULTS, ...(JSON.parse(raw) as Partial<NotificationPrefs>) } : DEFAULTS;
  } catch {
    return DEFAULTS;
  }
}

export function useNotificationPrefs() {
  const [prefs, setPrefs] = useState<NotificationPrefs>(readPrefs);

  const update = (key: keyof NotificationPrefs, value: boolean) => {
    const next = { ...prefs, [key]: value };
    setPrefs(next);
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {
      // Ignore — storage full or private browsing
    }
  };

  return { prefs, update };
}
